import { contentStyles } from "modules/storyblok/adapters/Content";

export const richTextStyles = {
  ...contentStyles,
  heading: { mb: 6 },
};
